import { motion } from 'framer-motion';
import userExpBadge from '../assets/user-experience-badge.png';
import innovationBadge from '../assets/innovation-badge.png';
import aiImage from '../assets/ai-illustration.svg'; // Replace with your image path
import iconAutomation from "../assets/icon-automation.png";
import iconStreamline from "../assets/icon-streamline.png";
import iconDecision from "../assets/icon-decision.png";
import iconEfficiency from "../assets/icon-efficiency.png";
import iconWorkload from "../assets/icon-workload.png";
import iconWorkflow from "../assets/icon-workflow.png";
import ChatbotIcon from "../assets/chatbot.png";
import AnalyticsIcon from "../assets/ai-analytics.png";
import RecognitionIcon from "../assets/ai-recognition.webp";

import robot from "../assets/aii-bot.png";
import badgeAutomation from "../assets/badge-automation.png";
import badgeIntegration from "../assets/badge-integration.png";
import badgeReduction from "../assets/badge-reduction.png";
import badgeComplexity from "../assets/badge-complexity.png";
import badgeDecision from "../assets/badge-decision.png";
import badgeStreamline from '../assets/badge-streamlined.png';
import grid from "../assets/grid-pattern.webp"; // your uploaded grid image
import React, { useEffect, useState } from "react";
import { useMediaQuery } from 'react-responsive';
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  

import { useNavigate } from 'react-router-dom'; 
import { useRef } from "react";
import { toast} from "react-toastify";

 

import { Helmet } from "react-helmet";










  
export default function AIServices() {
  
  
   const navigate = useNavigate();
   
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
    const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  
    const toggleMobileMenu = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };
  
    const toggleServicesDropdown = () => {
      setIsServicesOpen(!isServicesOpen);
    };
  
    const toggleIndustriesDropdown = () => {
      setIsIndustriesOpen(!isIndustriesOpen);
    };
  
    const toggleCompanyDropdown = () => {
      setIsCompanyOpen(!isCompanyOpen);
    };
  {/* FLOATING BADGES */}
  {/* Shared motion animation */}
  const floatY = { y: [0, -8, 0] };
  const floatTransition = { duration: 3.2, repeat: Infinity, ease: "easeInOut" };
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });
  const floatAnimation = {
  y: [0, -10, 0],
};

  
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  
  const services = [
  {
    image: ChatbotIcon,
    title: "Chatbot",
    description:
      "AI-driven chatbots boost user happiness by offering immediate and customized customer help.",
  },
  {
    image: AnalyticsIcon,
    title: "Analytics",
    description:
      "Marketing and corporate decisions by forecasting user behavior and market trends.",
  },
  {
    image: RecognitionIcon,
    title: "Recognition",
    description:
      "Enhances accessibility and user engagement on all platforms with Image and Voice recognition.",
  },
];
  const cards = [
    {
      icon: iconAutomation,
      text: "Complex tasks are automated at Lentera with AI integration.",
    },
    {
      icon: iconStreamline,
      text: "Operations are efficiently streamlined using it.",
    },
    { 
      icon: iconDecision,
      text: "Artificial intelligence improves decision-making.",
    },
    {
      icon: iconEfficiency,
      text: "Increased operational efficiency results from the integration.",
    },
    {
      icon: iconWorkload,
      text: "Workload from manual labor is decreased.",
    },
    {
      icon: iconWorkflow,
      text: "Workflow management is improved by AI-driven automation.",
    },
  ];
  const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.2 },
  }),
};

  // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
  const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

 return (
  <>
  
 
<Helmet>
        <title>AI Solutions | AI Integration & Automation by Lentera Technologies</title>
        <meta name="description" content="Lentera Technologies delivers AI solutions with machine learning, automation, chatbots, analytics, and recognition to enhance user experience and efficiency."/>
        <meta name="keywords" content=" AI solutions, Lentera Technologies, AI integration, machine learning, AI automation, chatbot solutions, AI analytics, voice recognition, image recognition."/>
      </Helmet>
 
    <section className="relative bg-black text-white font-poppins overflow-hidden w-full max-w-[full] h-[746px] mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-0">
  {/* Grid Background */}
  <img
    src={grid}
    alt="Grid Background"
    className="absolute top-0 left-0 w-full h-full object-cover opacity-100 pointer-events-none z-0"
  />

  {/* Gradient Blurs */}
  <div className="absolute bottom-0 left-0 h-full w-[100px] sm:w-[150px] lg:w-[200px] bg-gradient-to-r from-[] to-transparent blur-2xl z-10 pointer-events-none" />
  <div className="absolute bottom-0 right-0 h-full w-[100px] sm:w-[150px] lg:w-[200px] bg-gradient-to-l from-[] to-transparent blur-2xl z-10 pointer-events-none" />

  {/* Heading & Paragraph */}
  <div className="relative z-20 max-w-[637px] mx-auto text-center flex flex-col items-center gap-10">
    <h2 className="text-[32px] sm:text-[36px] md:text-[42px] lg:text-[48px] font-semibold leading-snug">
      <span className="bg-gradient-to-r from-[#7B41E6] to-[#ED72EF] text-transparent bg-clip-text">
        AI Solutions
      </span>
      <br />
      for your business
    </h2>
    <p className="text-[#D4D4D8] text-base sm:text-lg leading-relaxed">
      AI solutions improve app functionality and user experience by utilizing
      <br className="hidden sm:block" />
      machine learning models and algorithms.
    </p>
  </div>

  {/* Robot Image aligned to section bottom edge */}
  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-20">
    <img
      src={robot}
      alt="AI Robot"
      className="w-[260px] sm:w-[400px] md:w-[500px] lg:w-[577px] h-auto"
    />
  </div>

 {/* Floating Badges */}
  <motion.img
    src={badgeReduction}
    alt="Reduce Labor Cost"
    className="absolute w-[90px] sm:w-[120px] md:w-[180px] lg:w-[220px] top-[45%] left-[27%] z-30"
    animate={floatY}
    transition={{ ...floatTransition, duration: 3.1 }}
  />
  <motion.img
    src={badgeComplexity}
    alt="Minimized Complexity"
    className="absolute w-[90px] sm:w-[120px] md:w-[180px] lg:w-[220px] top-[45%] right-[27%] z-30"
    animate={floatY}
    transition={{ ...floatTransition, duration: 3.2 }}
  />
  <motion.img
    src={badgeIntegration}
    alt="Integration"
    className="absolute w-[100px] sm:w-[180px] md:w-[230px] lg:w-[280px] top-[57%] left-[16%] z-30"
    animate={floatY}
    transition={{ ...floatTransition, duration: 2.8 }}
  />
  <motion.img
    src={badgeAutomation}
    alt="Automation"
    className="absolute w-[110px] sm:w-[160px] md:w-[230px] lg:w-[350px] top-[70%] left-[4%] z-30"
    animate={floatY}
    transition={{ ...floatTransition, duration: 3.3 }}
  />
  <motion.img
    src={badgeDecision}
    alt="Decision Making"
    className="absolute w-[100px] sm:w-[140px] md:w-[200px] lg:w-[240px] top-[57%] right-[18%] z-30"
    animate={floatY}
    transition={{ ...floatTransition, duration: 3.1 }}
  />
  <motion.img
    src={badgeStreamline}
    alt="Streamline Operation"
    className="absolute w-[110px] sm:w-[160px] md:w-[230px] lg:w-[350px] top-[70%] right-[4%] z-30"
    animate={floatY}
    transition={{ ...floatTransition, duration: 3.4 }}
  />





</section>


      <section className="bg-black text-white font-poppins py-20 px-6 flex flex-col items-center">
      <section className="bg-black text-white font-poppins py-20 px-6 flex flex-col items-center">
      {/* Heading */}
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="text-4xl md:text-5xl font-semibold text-center mb-4"
      >
        AI in Lentera
      </motion.h2>

      {/* Description */}
     <motion.p
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6, delay: 0.2 }}
  viewport={{ once: true }}
  className="text-center font-poppins font-normal text-[16px] text-gray-200 max-w-3xl mb-16"
>
  Lentera’s integration of AI services expands our digital capabilities by utilizing <br/>
  cutting-edge AI technologies.
</motion.p>


      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 font-poppins gap-8 max-w-6xl w-full mx-auto">
  {[
    {
      title: "User experience",
      image: userExpBadge,
      text:
        "With the help of these services, we can streamline workflows, extract insightful information from data, and provide individualized user experiences for all of our platforms.",
    },
    {
      title: "Innovation",
      image: innovationBadge,
      text:
        "Lentera stimulates innovation in service delivery and customer engagement while optimizing operational efficiency through the integration of AI into our processes.",
    },
  ].map((card, index) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.3 + index * 0.2 }}
      viewport={{ once: true }}
      className="bg-gradient-to-br from-[#19004E] to-[#3A0039] rounded-2xl p-10 text-center"
    >
      <img
        src={card.image}
        alt={card.title}
        className="w-[90px] h-[80px] mx-auto mb-6"
      />
      <h3 className="text-2xl font-semibold text-white mb-4">{card.title}</h3>
      <p className="font-normal text-[16px] text-gray-100 leading-relaxed">
        {card.text}
      </p>
    </motion.div>
  ))}
</div>

    </section>
      
      
      
  

<section className="bg-black w-full px-4 sm:px-6 lg:px-8 py-20 flex flex-col items-center">
  {/* Section Heading */}
  <div className="text-center mb-12">
    <h2 className="text-white font-semibold text-[28px] sm:text-[36px] md:text-[44px] leading-tight mb-4">
      How AI works in Lentera
    </h2>
    
      <motion.p
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6, delay: 0.2 }}
  viewport={{ once: true }}
  className="text-center font-poppins font-normal text-[16px] text-gray-200 max-w-3xl mb-16"
>
  Analyzing user data and behaviors to provide personalized experiences, automate tasks,<br/>
      and enhance decision-making.
</motion.p>
  </div>

  {/* Card Section */}
 
  <div className="w-full max-w-[1280px] bg-[#2C1342] rounded-[48px] px-6 sm:px-10 md:px-12 xl:px-20 py-10 sm:py-14 md:py-16 flex flex-col lg:flex-row items-center justify-between gap-10">
  
  {/* Left Content - 40% */}
  <div className="w-full lg:w-[60%]">
    <span className="inline-block bg-[#A88BFF] text-white text-sm font-medium px-4 py-1 rounded-md mb-4">
      AI integration
    </span>
    <h3 className="text-white font-extrabold text-[28px] sm:text-[34px] md:text-[40px] mb-6 leading-tight">
      Digital Capabilities Via <br /> AI Integration
    </h3>
    <p className="text-[#D0CDE3] text-[16px] font-[400] leading-relaxed mb-4">
      At Lentera, we use AI tools like NLP and machine learning to simplify workflows and
      improve decisions. This keeps our solutions scalable, reliable,
      and at the cutting edge of tech.
    </p>
    <p className="text-[#D0CDE3] text-[16px] font-[400] leading-relaxed">
      This strategy guarantees that Lentera stays at the forefront of technological
      innovation while also improving the scalability and dependability of our solutions.
    </p>
  </div>

  {/* Right Image - 60% */}
  <div className="w-full lg:w-[40%] flex justify-center">
    <img
      src={aiImage} // ensure proper import
      alt="AI Integration Illustration"
      className="w-full max-w-[350px] object-contain"
    />
  </div>
</div>

</section>

    
    <section className="w-full bg-black text-white font-poppins py-20 px-4 sm:px-8 lg:px-16">
  <div className="max-w-[1440px] mx-auto">
    {/* Header Section */}
    <div className="flex flex-col lg:flex-row justify-between items-start gap-8 mb-16">
      <div className="w-full lg:w-1/2">
        <h2 className="text-[32px] sm:text-[36px] md:text-[40px] lg:text-[44px] xl:text-[48px] font-semibold leading-tight mb-4">
          Influence of <br />
          <span className="bg-gradient-to-r from-[#7B41E6] to-[#ED72EF] text-transparent bg-clip-text">
            Artificial Intelligence
          </span>
          <br /> in Lentera
        </h2>
      </div>
      <div className="w-full lg:w-1/2 text-[#D4D4D4] text-base sm:text-lg leading-relaxed">
        Artificial Intelligence has significantly enhanced Lentera’s capabilities by enabling smarter decision-making, personalizing user experiences, and streamlining operations through automation and data-driven insights.
      </div>
    </div>

    {/* Cards Section */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {cards.map((card, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: index * 0.1 }}
          viewport={{ once: true }}
          className="bg-[#262626] rounded-2xl p-6 flex gap-4 items-start"
        >
          <div className="w-14 h-14 flex items-center justify-center shrink-0">
            <img
              src={card.icon}
              alt="icon"
              className="w-[60px] h-[60px] object-contain"
            />
          </div>
          <p className="text-sm sm:text-base text-white leading-relaxed">{card.text}</p>
        </motion.div>
      ))}
    </div>
  </div>
</section>

<section className="w-full bg-black text-white font-poppins py-20 px-6">
      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-[1200px] font-semibold text-center mb-16 px-2 mx-auto"
      >
        <h2 className="text-4xl md:text-5xl leading-tight">
          Innovations in AI improving <br className="hidden md:block" />
          user experience
        </h2>
      </motion.div>

      {/* Services */}
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 px-2">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="flex flex-col gap-4 items-start"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={cardVariants}
            custom={index}
          >
            <img
              src={service.image}
              alt={service.title}
              className="w-[350px] h-[278px] object-contain"
            />
            <h3 className="text-xl font-semibold">{service.title}</h3>
            <p className="text-base text-gray-300 leading-relaxed">
              {service.description}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
        
     
    
    </section>
     <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
    </>

  );
}
